import type { ParseActionArgsResult, SofiaProposedAction } from "../model/types"
import { parseAlertActionArgs } from "./alertActionArgs"
import { parseModifyActionArgs } from "./modifyActionArgs"
import { parseNavigationActionArgs } from "./navigationActionArgs"
import { parseResourceActionArgs } from "./resourceActionArgs"
import { parseReviewActionArgs } from "./reviewActionArgs"
import { parseRunActionArgs } from "./runActionArgs"

export {
  buildActionTitle,
  buildMutationLabel,
  summarizeActionArgs,
} from "./actionLabels"
export {
  isAutoConfirmable,
  isAutoExecute,
  isDestructive,
  isModify,
  isServerExecuted,
} from "./actionGates"
export type { DroppedProposal } from "./proposedActions"
export {
  parseProposedActions,
  parseProposedActionsWithDrops,
} from "./proposedActions"

/** Narrow a proposal's loose args record into the kind's typed arguments. */
export function parseActionArgs(
  action: SofiaProposedAction,
): ParseActionArgsResult {
  const parsed =
    parseAlertActionArgs(action) ??
    parseRunActionArgs(action) ??
    parseResourceActionArgs(action) ??
    parseReviewActionArgs(action) ??
    parseModifyActionArgs(action) ??
    parseNavigationActionArgs(action)

  return parsed ?? { ok: false, problems: ["unsupported action kind"] }
}
